import { get, post, put, del } from './apiService';

const newsService = {
  getNews: async () => {
    try {
      return await get('admin/news', { withCredentials: false });
    } catch (err) {
      throw new Error(err.message || 'Failed to fetch news');
    }
  },

  getNewsById: async (newsId) => {
    try {
      return await get(`news/${newsId}`, { withCredentials: false });
    } catch (err) {
      throw new Error(err.message || 'Failed to fetch news');
    }
  },

  createNews: async (newsData) => {
    try {
      return await post('admin/news', newsData, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to create news');
    }
  },

  updateNews: async (newsId, newsData) => {
    try {
      return await put(`admin/news/${newsId}`, newsData, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to update news');
    }
  },

  deleteNews: async (newsId) => {
    try {
      return await del(`admin/news/${newsId}`, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to delete news');
    }
  },

  verifyNews: async (newsId) => {
    try {
      return await post(`admin/news/${newsId}/verify`, {}, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'Failed to verify news');
    }
  },
};

export default newsService;
